import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const o = c((e, r) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4114",
              width: 33,
              height: 32,
              x: 8,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M27.59 16.97c-.2-.25-.41-.5-.6-.76-2.06-2.71-2.24-7.44-2.24-7.49-.01-.4-.32-.72-.76-.72-.41.01-.74.34-.74.75 0 .04-.03 4.48-2.37 7.45-1.27 1.62-2.72 3.46-2.72 5.84 0 3.24 2.51 5.69 5.83 5.69 3.49 0 5.83-2.37 5.83-5.89.01-2.09-1.18-3.57-2.23-4.87M24 26.23c-2.51 0-4.33-1.76-4.33-4.19 0-1.86 1.22-3.41 2.45-4.99.9-1.15 1.49-2.48 1.88-3.73.38 1.3.95 2.67 1.79 3.79.2.27.42.53.63.79.98 1.22 1.91 2.37 1.91 3.93 0 2.72-1.66 4.4-4.33 4.4M37.77 29.27c-.2-.25-.41-.5-.6-.76-2.05-2.7-2.23-7.41-2.23-7.46a.76.76 0 0 0-.75-.73h-.01c-.41.01-.74.34-.74.75 0 .04-.03 4.45-2.36 7.43-1.27 1.62-2.71 3.45-2.71 5.82 0 3.23 2.5 5.67 5.82 5.67 3.48 0 5.82-2.36 5.82-5.87-.01-2.08-1.2-3.55-2.24-4.85m-3.59 9.23c-2.5 0-4.32-1.75-4.32-4.17 0-1.85 1.21-3.4 2.44-4.97.9-1.14 1.49-2.46 1.87-3.71.38 1.3.94 2.66 1.79 3.77.2.27.42.53.63.79.98 1.21 1.9 2.36 1.9 3.91.01 2.7-1.64 4.38-4.31 4.38M16.8 28.51c-2.05-2.7-2.23-7.41-2.23-7.46a.76.76 0 0 0-.75-.73h-.01c-.41.01-.74.34-.74.75 0 .04-.03 4.45-2.36 7.43C9.44 30.12 8 31.96 8 34.33 8 37.56 10.5 40 13.82 40c3.48 0 5.82-2.36 5.82-5.87 0-2.09-1.19-3.56-2.23-4.86-.22-.25-.42-.5-.61-.76m-2.98 9.99c-2.5 0-4.32-1.75-4.32-4.17 0-1.85 1.21-3.4 2.44-4.97.9-1.14 1.49-2.46 1.87-3.71.38 1.3.94 2.66 1.79 3.77.2.27.41.53.63.79.98 1.21 1.9 2.36 1.9 3.92 0 2.69-1.65 4.37-4.31 4.37"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4114)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-.121.196h47.797v48.84H-.121z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyVeryOilyIcon";
export {
  o as AgencyVeryOilyIcon,
  o as default
};
//# sourceMappingURL=index.js.map
